// The presigned S3 PUT is the one external call the dashboard makes. It uses XMLHttpRequest
// (native upload progress) and never services/api.js, whose interceptor adds the bearer header.
// A stalled PUT must not hold the upload modal busy forever.
export const PUT_TIMEOUT_MS = 10 * 60 * 1000;

export function putPresigned({ url, file, headers = {}, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.timeout = PUT_TIMEOUT_MS;
    Object.entries(headers).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(e.loaded / e.total);
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve({ status: xhr.status });
      else reject(new Error('Upload failed (' + xhr.status + ')'));
    };
    xhr.ontimeout = () => reject(new Error('Upload failed (timeout)'));
    xhr.onerror = () => reject(new Error('Upload failed (network)'));
    xhr.send(file);
  });
}
